import { makeHttpRequest } from "@/shared";

export const deleteDeposit = async (id) => {
    return (
        await makeHttpRequest({
            url: `/rent/deposit/${id}`,
            method: "DELETE",
        })
    ).data;
};
